const createMarkup = (body) => {
  return { __html: body };
};

export default createMarkup;
